/**
 * Silence noisy console channels in production builds.
 *
 * The codebase carries extensive emoji-prefixed debug tracing (🔐/🥧/📅/...)
 * that is useful in development but noise in a resident-facing production
 * console. Rather than sweeping hundreds of call sites, production builds
 * no-op the chatty channels at boot.
 *
 * - warn/error always pass through: they carry operational failures
 *   (RLS fallbacks, fetch errors, chunk-load failures) that must stay
 *   visible in production.
 * - Field debugging stays available via the same escape hatch debugLog
 *   uses: localStorage.setItem('iconDebug', '1') then reload.
 * - localStorage access can THROW in sandboxed iframes (this app is
 *   iframe-embedded), so it is guarded — a blocked storage read means
 *   "no debug override", never a crash.
 *
 * @param env injectable for tests; defaults to the build-time NODE_ENV
 */
export function quietConsoleForProduction(env: string | undefined = process.env.NODE_ENV): void {
  if (env !== 'production') return;

  let debugEnabled = false;
  try {
    debugEnabled = localStorage.getItem('iconDebug') === '1';
  } catch {
    debugEnabled = false;
  }
  if (debugEnabled) return;

  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
}
